import {FC, useMemo} from 'react';
import {HivesFiltersItem as Box, HivesFiltersItemTitle as Title} from 'features/hives/ui/styles';
import {SearchList} from 'shared/ui/searchList';

type Item = {id: string; name: string; isSelected: boolean};

type Props = {
  items: Item[];
  onItemClick: (id: string) => void;
  onReset: () => void;
  isDrawer?: boolean;
  hideHeader?: boolean;
};

export const HivesDictionariesFilter: FC<Props> = ({
  items,
  onItemClick,
  onReset,
  isDrawer = false,
  hideHeader = false,
}) => {
  const hasSelected = useMemo(() => items.some((i) => i.isSelected), [items]);

  console.log(items);

  return (
    <Box>
      {!hideHeader && (
        <Title>
          <span>Состояние</span>
          {hasSelected && <button onClick={onReset}>Сбросить</button>}
        </Title>
      )}
      <SearchList items={items} isDrawer={isDrawer} onItemClick={onItemClick} />
    </Box>
  );
};
